import {Component} from "./Component";
import {toPixels} from "../util/units";
import gsap, {Power2} from "gsap";

export class Scroll extends Component {
    static name = "scroll";

    get name() {
        return Scroll.name;
    }

    constructor(el) {
        super(el);

        console.log("height", toPixels(this.el.offsetHeight));
        // document.body.style.height = toPixels(this.el.getBoundingClientRect().height);

        // this.addEventListener(window, "scroll", this.onScroll.bind(this));
    }

    /**
     * @param {Event} e
     */
    onScroll(e) {
        return;
        e.preventDefault();
        const offset = window.scrollY;

        gsap.to(this.el, {
            y: toPixels(-1* offset),
            ease: Power2.easeOut,
            duration: .8,
        });
    }
}
